(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3079],{

/***/ 8053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-ellipsis-text/index.js
var react_ellipsis_text = __webpack_require__(48);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.mjs
var io = __webpack_require__(4920);
// EXTERNAL MODULE: ./node_modules/react-icons/rx/index.mjs
var rx = __webpack_require__(5908);
// EXTERNAL MODULE: ./node_modules/react-use-scroll-direction/dist/react-use-scroll-direction.esm.js
var react_use_scroll_direction_esm = __webpack_require__(1150);
// EXTERNAL MODULE: ./store/search-store.js
var search_store = __webpack_require__(1401);
// EXTERNAL MODULE: ./components/utils/fileutil.js
var fileutil = __webpack_require__(2190);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5258);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(3855);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Navbar/CartIconSvg.jsx


var _excluded = ["width", "height", "stroke", "color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var CartIconSvg = function CartIconSvg(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 21 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 22 : _ref$height,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 1 : _ref$stroke,
      color = _ref.color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "-1 -1 22 24"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "a",
        x1: "50%",
        x2: "50%",
        y1: "0%",
        y2: "100%",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "0%",
          stopColor: "var(--color-primary)"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "100%",
          stopColor: "var(--color-primary)"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fill: color || "var(--color-primary)",
        stroke: color || "var(--color-primary)",
        strokeWidth: stroke,
        fillRule: "nonzero",
        d: "M15.408 4.187h-.715a4.202 4.202 0 0 0-8.405 0h-.853a2.916 2.916 0 0 0-2.861 2.29L.07 17.64a2.93 2.93 0 0 0 2.861 3.573H17.91a2.932 2.932 0 0 0 2.861-3.573L18.269 6.477a2.915 2.915 0 0 0-2.862-2.29zM10.49.953a3.253 3.253 0 0 1 3.249 3.234H7.242A3.251 3.251 0 0 1 10.49.953zm8.964 18.564c-.374.47-.943.743-1.544.742H2.932a1.979 1.979 0 0 1-1.93-2.41L3.504 6.686a1.967 1.967 0 0 1 1.93-1.545h.853v2.294a.477.477 0 1 0 .954 0V5.141h6.499v2.294a.477.477 0 1 0 .954 0V5.141h.714a1.968 1.968 0 0 1 1.93 1.545L19.84 17.85c.133.586-.009 1.2-.386 1.668z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: 10.5,
        cy: 13.5,
        r: 2.5,
        fill: "url(#a)"
      })]
    })]
  }));
};

/* harmony default export */ var Navbar_CartIconSvg = (CartIconSvg);
;// CONCATENATED MODULE: ./components/Navbar/index.jsx














var SearchSidebar = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(6660), __webpack_require__.e(1607), __webpack_require__.e(7103), __webpack_require__.e(6893), __webpack_require__.e(3673)]).then(__webpack_require__.bind(__webpack_require__, 3673));
}, {
  loading: function loading() {
    return null;
  },
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(3673)];
    }
  }
});

var NavBar = function NavBar(props) {
  var _props$store$storeBan, _props$store, _props$store$storeBan2, _props$store2, _props$theme, _props$theme2, _props$store3;

  var _useState = (0,react.useState)(""),
      direction = _useState[0],
      setDirection = _useState[1];

  var _useScrollDirection = (0,react_use_scroll_direction_esm/* useScrollDirection */.C)(),
      isScrollingUp = _useScrollDirection.isScrollingUp,
      isScrollingDown = _useScrollDirection.isScrollingDown;

  var _useState2 = (0,react.useState)(false),
      isSideNavOpen = _useState2[0],
      setIsSideNavOpen = _useState2[1];

  var _useStore = (0,search_store/* default */.Z)(function (state) {
    return {
      isSearchOpen: state.isSearchOpen,
      setIsSearchOpen: state.setIsSearchOpen,
      shouldSearchReopen: state.shouldSearchReopen,
      setShouldSearchReopen: state.setShouldSearchReopen
    };
  }),
      isSearchOpen = _useStore.isSearchOpen,
      setIsSearchOpen = _useStore.setIsSearchOpen,
      shouldSearchReopen = _useStore.shouldSearchReopen,
      setShouldSearchReopen = _useStore.setShouldSearchReopen;

  var searchInputRef = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();
  var _props$homePage = props.homePage,
      homePage = _props$homePage === void 0 ? false : _props$homePage,
      _props$showSearch = props.showSearch,
      showSearch = _props$showSearch === void 0 ? true : _props$showSearch;
  (0,react.useEffect)(function () {
    if (shouldSearchReopen === router.asPath && !isSearchOpen) {
      setIsSearchOpen(true);
    } else {
      setIsSearchOpen(false);
    }
  }, [router.asPath, setIsSearchOpen, setShouldSearchReopen, shouldSearchReopen]);
  (0,react.useEffect)(function () {
    isScrollingDown && setDirection("down");
    isScrollingUp && setDirection("up");
  }, [isScrollingDown, isScrollingUp]);

  var checkoutShouldHide = function checkoutShouldHide() {
    if ( true && window.scrollY > 120) {
      return true;
    }

    return false;
  };

  var makeBGWhite = function makeBGWhite() {
    var shouldHide = false;

    if (true) {
      if (window.scrollY > 30) {
        shouldHide = true;
      }
    }

    return shouldHide;
  };

  var hasBanner = (_props$store$storeBan = (_props$store = props.store) === null || _props$store === void 0 ? void 0 : (_props$store$storeBan2 = _props$store.storeBanner) === null || _props$store$storeBan2 === void 0 ? void 0 : _props$store$storeBan2.text) !== null && _props$store$storeBan !== void 0 ? _props$store$storeBan : false;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      className: homePage ? "z-50 flex h-[4.5rem] w-full items-center justify-between bg-background transition-all duration-300 ".concat(hasBanner ? "top-20" : "top-0", " ").concat(direction === "up" ? "opacity-100" : "", " ").concat(direction === "down" && checkoutShouldHide() ? "-top-16 opacity-0" : "") : "fixed left-1/2 top-0 z-[99] flex h-[72px] w-full max-w-[var(--max-width)] -translate-x-1/2 flex-row items-center justify-between bg-background opacity-100 transition-all duration-300 ease-in-out ".concat(direction === "up" ? "bg-background" : "", " ").concat(direction === "down" && checkoutShouldHide() ? "-top-[60px]" : "", " ").concat(direction === "down" && makeBGWhite() ? "bg-background" : "", " mb-5"),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mx-auto flex h-[5rem] w-full max-w-[var(--max-width)] items-center justify-between px-6 py-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative z-10 flex w-full items-center justify-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "absolute left-0 cursor-pointer text-primary",
            "aria-label": "Toggle side navigation menu",
            onClick: function onClick() {
              return props.toggleSideNav();
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(rx/* RxHamburgerMenu */.Bbf, {
              size: 28
            })
          }), (_props$store2 = props.store) !== null && _props$store2 !== void 0 && _props$store2.logo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            unoptimized: true,
            src: function () {
              // eslint-disable-next-line no-undef
              var urlPath = props.store.logo ? new URL(props.store.logo).pathname : "";
              var extractedImageName = (0,fileutil/* parseFileName */.x)(urlPath).name;
              return "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(extractedImageName, ".jpg?quality=50");
            }(),
            alt: "".concat(props.store.storeName, " Logo"),
            width: ((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.logoShape) === "rectangle" ? 120 : 60,
            height: 60,
            className: "object-contain ".concat(((_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.logoShape) === "rectangle" ? "" : "rounded-full"),
            layout: "fixed",
            onClick: function onClick() {
              return router.push("/");
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "inline-block cursor-pointer text-center text-lg font-bold text-primary",
            onClick: function onClick() {
              return window.location.href = window.location.origin;
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_ellipsis_text["default"], {
              text: props.storeName,
              length: 25,
              tail: "..."
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "absolute right-0 z-10 flex gap-10",
            children: [((_props$store3 = props.store) === null || _props$store3 === void 0 ? void 0 : _props$store3.homePageEnabled) && showSearch && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "cursor-pointer text-primary",
              "aria-label": "Open search menu",
              onClick: function onClick() {
                setIsSearchOpen(!isSearchOpen);
                if (searchInputRef.current && !isSearchOpen) searchInputRef.current.focus();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(io/* IoIosSearch */.FKI, {
                size: 26
              })
            }), props.cartActive && !props.hideInAdvance && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "mt-0.5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                className: "mt-1.5 cursor-pointer text-primary",
                "aria-label": "Open cart",
                onClick: function onClick() {
                  return props.handleShowCart(true);
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar_CartIconSvg, {
                  stroke: 0.5
                })
              })
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchSidebar, {
      isOpen: isSearchOpen,
      toggleDrawer: function toggleDrawer() {
        return setIsSearchOpen(!isSearchOpen);
      },
      store: props.store,
      searchRef: searchInputRef
    })]
  });
};

/* harmony default export */ var Navbar = (NavBar);

/***/ }),

/***/ 6121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SideNavDrawer; }
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./hooks/useCollection.js
var useCollection = __webpack_require__(2126);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/bundle-mjs.mjs
var bundle_mjs = __webpack_require__(2668);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Carousel/ArrowSvg.jsx



var ArrowSvg = function ArrowSvg(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: (0,bundle_mjs/* twMerge */.m6)("icon icon-arrow icon--medium ".concat(className)),
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M7.5 3.74121L13.75 9.99121L7.5 16.2412",
      stroke: color,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

/* harmony default export */ var Carousel_ArrowSvg = (ArrowSvg);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/LinkItem.jsx




var LinkItem = function LinkItem(_ref) {
  var href = _ref.href,
      label = _ref.label,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: href,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: (0,bundle_mjs/* twMerge */.m6)("m-0 opacity-100", className),
      children: label
    })
  });
};

/* harmony default export */ var components_LinkItem = (LinkItem);
;// CONCATENATED MODULE: ./components/SideNavDrawer.jsx







var SideNavDrawer = function SideNavDrawer(_ref) {
  var isOpen = _ref.isOpen,
      toggleDrawer = _ref.toggleDrawer,
      store = _ref.store;
  var router = (0,next_router.useRouter)();

  var _useCollection = (0,useCollection/* default */.Z)(store.id, ""),
      collectionsData = _useCollection.data,
      isCollectionsLoading = _useCollection.isLoading,
      collectionsError = _useCollection.error;

  var collections = collectionsData ? collectionsData.collections : [];
  if (collectionsError) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: "Error loading collections"
  });

  var onClickItem = function onClickItem(path) {
    router.push(path);
    toggleDrawer();
  };

  if (collectionsError) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: "Error loading collections"
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
    className: "fixed left-0 top-0 z-[101] h-screen w-screen transform overflow-y-auto bg-background text-fontBackground shadow-lg transition-transform ".concat(isOpen ? "translate-x-0" : "-translate-x-full"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex items-center p-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-lg font-bold",
        children: store === null || store === void 0 ? void 0 : store.storeName
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: "absolute right-5 top-10 z-50 inline-block w-[22px] border-0 bg-transparent",
        onClick: toggleDrawer,
        "aria-label": "Close drawer",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative h-[15px] w-full rotate-0 transform cursor-pointer transition duration-500 ease-in-out ".concat(isOpen ? "open" : ""),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "duration-250 absolute left-0 top-[7px] block h-[2px] w-full transform rounded-lg bg-primary opacity-100 transition ease-in-out ".concat(isOpen ? "rotate-45" : "rotate-0")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "duration-250 absolute left-0 top-[7px] block h-[2px] w-full transform rounded-lg bg-primary opacity-100 transition ease-in-out ".concat(isOpen ? "-rotate-45" : "rotate-0")
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
      className: "mt-3",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "space-y-0 text-lg",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          onClick: function onClick() {
            return toggleDrawer();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinkItem, {
            href: "/",
            label: "Home",
            className: "block px-4 py-2 hover:opacity-80"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          onClick: function onClick() {
            return toggleDrawer();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinkItem, {
            href: "/shop",
            label: "Shop",
            className: "block px-4 py-2 hover:opacity-80"
          })
        }), isCollectionsLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {}) : collections.length > 0 && collections.map(function (collection) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: "flex cursor-pointer items-center justify-between px-4 py-2 hover:opacity-80",
              onClick: function onClick() {
                return onClickItem("/shop?collection=".concat(collection.name));
              },
              children: [collection.name, /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel_ArrowSvg, {
                className: "h-5 w-5",
                color: "var(--font-background)"
              })]
            })
          }, collection._id);
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          onClick: function onClick() {
            return toggleDrawer();
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_LinkItem, {
            href: "/contact",
            label: "Contact us",
            className: "mb-4 block px-4 py-2 hover:opacity-80"
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var components_SideNavDrawer = (SideNavDrawer);

/***/ }),

/***/ 2190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ parseFileName; }
/* harmony export */ });
var parseFileName = function parseFileName(url) {
  if (!url) return "";
  var parts = url.split("/");
  var filename = parts[parts.length - 1].split("?")[0];
  return {
    name: filename.substring(0, filename.lastIndexOf(".")),
    ext: filename.substring(filename.lastIndexOf("."))
  };
};

/***/ }),

/***/ 2126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ usePaginatedCollections; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5602);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6661);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1766);
/* harmony import */ var _services_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7925);





var fetchCollections = /*#__PURE__*/function () {
  var _ref = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(storeId) {
    var source,
        response,
        _args = arguments;
    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            source = _args.length > 1 && _args[1] !== undefined ? _args[1] : "featured";
            _context.next = 3;
            return fetch("".concat(_services_helper__WEBPACK_IMPORTED_MODULE_1__/* .publicServerEndpoint */ .v2, "/v3/collection/store/").concat(storeId).concat(source ? "?source=".concat(source) : ""));

          case 3:
            response = _context.sent;

            if (response.ok) {
              _context.next = 6;
              break;
            }

            throw new Error("Failed to fetch collections");

          case 6:
            return _context.abrupt("return", response.json());

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchCollections(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchCollectionsPage = /*#__PURE__*/function () {
  var _ref3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(_ref2) {
    var storeId, _ref2$pageParam, pageParam, _ref2$limit, limit, response;

    return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            storeId = _ref2.storeId, _ref2$pageParam = _ref2.pageParam, pageParam = _ref2$pageParam === void 0 ? 1 : _ref2$pageParam, _ref2$limit = _ref2.limit, limit = _ref2$limit === void 0 ? 5 : _ref2$limit;
            _context2.prev = 1;
            _context2.next = 4;
            return fetch("".concat(_services_helper__WEBPACK_IMPORTED_MODULE_1__/* .publicServerEndpoint */ .v2, "/v3/collection/store/").concat(storeId, "?limit=").concat(limit, "&page=").concat(pageParam));

          case 4:
            response = _context2.sent;

            if (response.ok) {
              _context2.next = 7;
              break;
            }

            throw new Error("Failed to fetch collections: ".concat(response.status, " ").concat(response.statusText));

          case 7:
            return _context2.abrupt("return", response.json());

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](1);
            console.error("Error fetching collections page ".concat(pageParam, ":"), _context2.t0);
            throw _context2.t0;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 10]]);
  }));

  return function fetchCollectionsPage(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var useCollection = function useCollection(storeId) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "featured";
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(["collections", storeId, source], function () {
    return fetchCollections(storeId, source);
  }, {
    enabled: !!storeId
  });
};
/**
 * Hook for fetching collections with pagination
 * @param {string} storeId - Store ID to fetch collections for
 * @param {number} limit - Number of collections per page
 * @returns {Object} - React Query infinite query result
 */


var usePaginatedCollections = function usePaginatedCollections(storeId) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useInfiniteQuery */ .N)(["paginatedCollections", storeId, limit], function (_ref4) {
    var _ref4$pageParam = _ref4.pageParam,
        pageParam = _ref4$pageParam === void 0 ? 1 : _ref4$pageParam;
    return fetchCollectionsPage({
      storeId: storeId,
      pageParam: pageParam,
      limit: limit
    });
  }, {
    enabled: !!storeId,
    getNextPageParam: function getNextPageParam(lastPage, allPages) {
      // Use the pagination.pages from the response to determine if there are more pages
      if (!lastPage.pagination || !lastPage.pagination.pages) {
        return undefined; // No pagination info available
      }

      var currentPage = allPages.length;
      var totalPages = lastPage.pagination.pages; // Return undefined if we're at the last page to prevent extra API calls

      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    retry: 2,
    refetchOnWindowFocus: false
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (useCollection);


/***/ }),

/***/ 1401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
// stores/useStore.js

var useStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function (set) {
  return {
    data: null,
    scrollPosition: 0,
    setScrollPosition: function setScrollPosition(position) {
      return set({
        scrollPosition: position
      });
    },
    setData: function setData(data) {
      return set({
        data: data
      });
    },
    searchQuery: "",
    setSearchQuery: function setSearchQuery(query) {
      return set({
        searchQuery: query,
        scrollPosition: 0
      });
    },
    isSearchOpen: false,
    setIsSearchOpen: function setIsSearchOpen(isSearchOpen) {
      set({
        isSearchOpen: isSearchOpen
      });
    },
    shouldSearchReopen: false,
    setShouldSearchReopen: function setShouldSearchReopen(shouldSearchReopen) {
      set({
        shouldSearchReopen: shouldSearchReopen
      });
    }
  };
});
/* harmony default export */ __webpack_exports__["Z"] = (useStore);

/***/ }),

/***/ 214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","cart":"Home_cart__LyzTg","about":"Home_about__6Y_1_","profilePic":"Home_profilePic__7nemD","footerTagline":"Home_footerTagline__wH1if","notFound":"Home_notFound___6xAl","notFoundMessage":"Home_notFoundMessage__KeTwU","notFoundHeadHome":"Home_notFoundHeadHome__0_jo1","link":"Home_link__mt0ji","title404":"Home_title404__7ZWAE"};

/***/ })

}]);